import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { FidelityAvailablePages } from 'app/shared/components/fidelity-base-page/fidelity-base-page.types';
import { AuthService } from '../../../../core/auth/auth.service';
import { FidelityBasePageComponent } from '../../../../shared/components/fidelity-base-page/fidelity-base-page.component';
import { FidelityOverlayPageWrapperComponent } from '../../../../shared/components/fidelity-overlay-page-wrapper/fidelity-overlay-page-wrapper.component';
import { TbConfirmationService } from '../../../../shared/services/tb-confirmation/tb-confirmation.service';
import { TbConfirmationConfig } from '../../../../shared/services/tb-confirmation/tb-confirmation.types';
import { FidelityPersonalDataService } from '../../personal-data/personal-data.service';

@Component({
    selector: 'app-delete-account',
    imports: [FidelityOverlayPageWrapperComponent, TranslocoDirective, MatButton, MatProgressSpinner],
    templateUrl: './delete-account-page.component.html',
    styleUrl: './delete-account-page.component.scss',
})
export class DeleteAccountPageComponent extends FidelityBasePageComponent {
    public availablePages: FidelityAvailablePages = {};
    protected disableCrudActions = this.personalDataService.disableCrudActions;

    constructor(
        private personalDataService: FidelityPersonalDataService,
        private tbConfirmationService: TbConfirmationService,
        private authService: AuthService
    ) {
        super();
    }

    deletePersonalData() {
        const confirmationPrompt: TbConfirmationConfig = {
            title: this.translocoService.translate('fidelity-app.account.delete.confirmation-title'),
            message: this.translocoService.translate('fidelity-app.account.delete.confirmation-subtitle'),
            icon: {
                color: 'error',
            },
            dismissible: false,
            actions: {
                cancel: {
                    show: true,
                    label: this.translocoService.translate('generic.no'),
                },
                confirm: {
                    show: true,
                    label: this.translocoService.translate('generic.yes'),
                    color: 'warn',
                },
            },
            panelCass: this.fidelityAppNavService.deviceIsMobile ? 'mobile' : 'default',
        };
        const dialogRef = this.tbConfirmationService.open(confirmationPrompt);

        // Subscribe to afterClosed from the dialog reference
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                this.personalDataService
                    .deletePersonalData()
                    .pipe(takeUntilDestroyed(this.destroyRef))
                    .subscribe((_) => {
                        this.authService.forceSignOut();
                        this.notifyResult(
                            this.translocoService.translate('fidelity-app.account.delete.notification-caption')
                        );
                        this.navToRoot();
                    });
            }
        });
    }
}
